export default __webpack_public_path__ + "static/og-image-1cb9f8fdeabc4f980b4e014ca614f6dc.jpg";